import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiState } from '../services/api.state';
import { BYPASS_AUTH, IS_MOTOR_VUELOS_API } from '../context/api.context';
import { environment } from '../../../../environments/environment';

export const motorVuelosInterceptor: HttpInterceptorFn = (req, next) => {
  const apiState = inject(ApiState);

  const isMv = req.context.get(IS_MOTOR_VUELOS_API);
  const skipAuth = req.context.get(BYPASS_AUTH);

  if (!isMv || skipAuth) return next(req);

  const token = apiState.accessToken();

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'Ocp-Apim-Subscription-Key': environment.ocpApimSubscriptionKey,
    },
  });
  return next(authReq);
};
